module.exports = __webpack_public_path__ + "static/img/career-course-image2.33a1b77a.png";